var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "navbar-timezone-clocks" }, [
    _c("div", { staticClass: "time-item" }, [
      _c("span", { staticClass: "label" }, [_vm._v("本地")]),
      _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_setup.localTime))]),
    ]),
    _c("div", { staticClass: "time-item" }, [
      _c("span", { staticClass: "label" }, [
        _vm._v(_vm._s(_setup.countryCnName)),
      ]),
      _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_setup.lagosTime))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }